import { defineStore } from 'pinia';
import { breakpoints } from '~~/configs/breakpoints.config';
import type { IBreakpoint } from '~~/types/local_types';

type TStoreState = {
  currentBreakpoint: IBreakpoint | undefined;
  index: number | undefined;
};

const useBreakpointsStore = defineStore('breakpoints', {
  state: (): TStoreState => {
    return {
      currentBreakpoint: undefined,
      index: 0,
    };
  },
  actions: {
    setCurrentBreakpoint(breakpoint: IBreakpoint) {
      this.$state = {
        currentBreakpoint: breakpoint,
        index: breakpoints.indexOf(breakpoint),
      };

      const devMode =
        import.meta.dev || (import.meta.client && window.location.href.includes('.dev.'));
      if (devMode) {
        console.info(`✔ Breakpoint changed to ${this.$state.currentBreakpoint?.name}`);
      }
    },
  },
  getters: {
    getCurrentBreakpoint: (state) => state.currentBreakpoint,
    getCurrentBreakpointIndex: (state) => state.index,
  },
});

export default useBreakpointsStore;
